export const parseResponseError = errors =>
  Object.keys(errors).reduce((acc, key) => {
    const value = errors[key];
    return { [key]: Array.isArray(value) ? value[0] : value, ...acc };
  }, {});
